import { createSlice } from "@reduxjs/toolkit";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";
import apiService from "../../services/api.service";

export const getConsignList = createApiThunk(
  "getConsignList",
  apiService.getConsignList,
);

export const createConsign = createApiThunk(
  "createConsign",
  apiService.createConsign,
);

export const initialData = {
  consignLoading: false,
  consignListLoading: false,
  consignList: [],
};

const dataSlice = createSlice({
  name: "consign",
  initialState: initialData,
  reducers: {},
  extraReducers: (builder) => {
    createApiCase(builder, getConsignList, {
      loading: "consignListLoading",
      fulfilled: (state, action) => {
        state.consignList = action.payload.data.aaData;
      },
    });
    createApiCase(builder, createConsign, {
      loading: "consignLoading",
    });
  },
});

export default dataSlice.reducer;
